// ABOUTME: Cancelling an upload: the error a cancelled step rejects with, a pause that ends at once on a cancel, and the
// ABOUTME: check of a signal read after an await — where a property narrowed before it would lie.

export const abortError = () => new DOMException("The upload was cancelled", "AbortError")

/** Read through a call: an abort may come while a request or a pause is awaited. */
export const isCancelled = (signal: AbortSignal): boolean => signal.aborted

/** Waits `ms`, or rejects as soon as the upload is cancelled. */
export const pause = (ms: number, signal: AbortSignal) =>
  new Promise<void>((resolve, reject) => {
    if (signal.aborted) {
      reject(abortError())
      return
    }
    const onAbort = () => {
      clearTimeout(timer)
      reject(abortError())
    }
    const timer = setTimeout(() => {
      signal.removeEventListener("abort", onAbort)
      resolve()
    }, ms)
    signal.addEventListener("abort", onAbort, { once: true })
  })
